import { Navigate, useLocation } from 'react-router-dom'
import type { Permission } from '@/types'
import { useAuthStore } from '@/store/auth'
import { Forbidden } from '@/components/common/Forbidden'

export function ProtectedRoute({
  children,
  permission,
}: {
  children: JSX.Element
  permission?: Permission
}) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const can = useAuthStore((s) => s.can)
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  if (permission && !can(permission)) {
    return <Forbidden />
  }
  return children
}
